const InteractionEventName = {};
export default InteractionEventName;

InteractionEventName.DIALOG_OPTION_CHOSEN = "dialog_option_chosen";
InteractionEventName.DIALOG_STARTED = "dialog_started";
InteractionEventName.DIALOG_ENDED = "dialog_ended";